<template>
  <div>
    <ComponenteSolicitacaoHistorico
      :chave-externa="chaveExterna"
      :funcionalidade="funcionalidade"
      :lista-externa="listaExterna"
      :lista-interna="listaInterna"
    >
      <template v-slot:externo="{card}">
        <slot
          :card="card"
        />
      </template>

      <template v-slot:interno="{card}">
        <div
          @click="detalhe(card)"
        >
          <ListaStatusCard
            :card="card"
          />
        </div>
      </template>
    </ComponenteSolicitacaoHistorico>
  </div>
</template>

<script>
import ListaStatusCard from '@/components/TemplateSolicitacao/componentes/ListaStatusCard'
import { mapState } from 'vuex'
import ComponenteSolicitacaoHistorico from '@/components/TemplateSolicitacao/componentes/ComponenteSolicitacaoHistorico'

export default {
  name: 'SolicitacaoHistoricoGeral',
  components: { ComponenteSolicitacaoHistorico, ListaStatusCard },
  props: {
    funcionalidade: {
      type: Object,
      default: () => ({})
    },
    listaExterna: {
      type: Array,
      default: () => []
    },
    chaveExterna: {
      type: String,
      default: ''
    },
    rotaDetalhe: {
      type: String,
      defalut: ''
    }
  },
  data () {
    return {
      listaInterna: []
    }
  },
  computed: {
    ...mapState('SetupApp', ['apiAcesso'])
  },
  methods: {
    async init () {
      await this.getList()
    },
    detalhe (card) {
      return this.$router.push({
        path: this.rotaDetalhe,
        query: {
          idOcorrencia: card['id_ocorrencia']
        }
      })
    },
    async getList () {
      const response = await this.apiAcesso.meusProtocolos.lista({
        loading: true,
        handlerErrorIgnore: true
      })

      this.listaInterna = response.data.contratos
    },
    goToHistorico (contrato) {
      return this.$router.push({
        path: this.rotaHistorico,
        query: {
          numeroContrato: contrato.numeroContrato || 'n/a'
        }
      })
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style scoped>

</style>
